import { melbourneInputToUtcIso, utcIsoToMelbourneInput } from '../../lib/melbourne-time';
import { SubscriptionPackageDraft } from '../../queries/subscriptionPackages';

interface SaleWindowFieldsProps {
  draft: SubscriptionPackageDraft;
  onChange: (draft: SubscriptionPackageDraft) => void;
  inputClass: string;
}

/** On-sale-from/until inputs: entered and shown on the Melbourne clock, held in the draft as UTC ISO. */
export function SaleWindowFields({ draft, onChange, inputClass }: SaleWindowFieldsProps) {
  return (
    <div className="col-span-2 border-t border-border pt-3">
      <h3 className="text-sm font-medium">Sale window</h3>
      <p className="mb-2 text-xs text-muted-foreground">
        Melbourne time. Outside the window the package is not listed or sold, but it stays active, so people who bought
        it keep their access. Leave empty for no limit.
      </p>
      <div className="grid grid-cols-2 gap-3">
        <label className="text-sm">
          On sale from (Melbourne time)
          <input
            type="datetime-local"
            className={inputClass}
            value={utcIsoToMelbourneInput(draft.sale_starts_at)}
            onChange={(e) => onChange({ ...draft, sale_starts_at: melbourneInputToUtcIso(e.target.value) })}
          />
        </label>
        <label className="text-sm">
          On sale until (Melbourne time)
          <input
            type="datetime-local"
            className={inputClass}
            value={utcIsoToMelbourneInput(draft.sale_ends_at)}
            onChange={(e) => onChange({ ...draft, sale_ends_at: melbourneInputToUtcIso(e.target.value) })}
          />
        </label>
      </div>
    </div>
  );
}
